import { useSelector } from "react-redux";
import ClienteHeader from "./ClienteHeader";
import { getDetalhesCliente, getPreenchimentoCliente } from "../../selectors/clientes.selectors";
import { getUsuarioLogado } from "../../selectors/usuario.selectors";
import { useCallback } from "react";
import { removeNonDigitsFromString } from "../../utils/basic";

const ClienteHeaderConnected = ({ cliente, tab, handleTabChange }) => {
  const usuarioLogado = useSelector(getUsuarioLogado);

  const handlePhoneClick = useCallback((phone, msg) => {
    const mensagem = encodeURI(
      msg ?? "Olá,\nSou da Taya e vou te ajudar neste processo."
    );

    window.open(
      `https://wa.me/${removeNonDigitsFromString(phone)}?text=${mensagem}`
    );
  }, []);

  return (
    <ClienteHeader
      cliente={cliente}
      tab={tab}
      handleTabChange={handleTabChange}
      handlePhoneClick={handlePhoneClick}
      perfil={usuarioLogado.perfil}
    />
  );
};

export default ClienteHeaderConnected;
